module.exports = __webpack_public_path__ + "static/media/download-icon.eb0ce8ce.svg";